import { Component, OnInit,ViewChild,AfterViewInit } from '@angular/core';
import { LibraryService, Dropobj } from '../services/library.service';
import { HttpClient } from '@angular/common/http';
import {NgbModal, ModalDismissReasons, NgbModalOptions,NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import { AppGlobals } from '../shared/app.global';
import { ChartType } from 'chart.js';
import { MultiDataSet } from 'ng2-charts';
import { ChartDataSets , RadialChartOptions } from 'chart.js';
import { SingleDataSet, Label, monkeyPatchChartJsLegend, monkeyPatchChartJsTooltip } from 'ng2-charts';
import {  ChartOptions } from 'chart.js';
import { Color} from 'ng2-charts';

//import {NgbModal, ModalDismissReasons,NgbModalOptions,NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
//import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';
//import {DialogService} from 'primeng/dynamicdialog';

@Component({
  selector: 'app-books',
  templateUrl: './books.component.html',
  styleUrls: ['./books.component.scss'],
  providers:[LibraryService],
  
})
export class BooksComponent implements OnInit {
  bookdetails:any[];
  depts:any[];
  catgories:any[];
  suppliers:any[];
  publishers:any[];
  sources:any[];
  subjects:any[];
  author: Dropobj[];
  statuses: any[];
  acctypes: any[];
  @ViewChild('dt') table: any;
  closeResult: string;
  modalOptions:NgbModalOptions;
  smmodalOptions:NgbModalOptions;
  private modalRef: NgbModalRef;
  private smallmodalRef: NgbModalRef;
  booksmodel:any={};
  dashcount:any={};
  bookinfo:any={};
  oprtype:string;
  filtcatgory:any[];
  bindtypes:any[];
  laguages:any[];
  currency:any[];
  lsection=[];
  issuehis=[];
  arrnewar=[];
  selfield:any={};
  selpub:any={};
  selsup:any={};
  selsub:any={};
  //=[{'id':'1','name':'English'},{'id':'2','name':'Hindi'}];
  tab=1;
  selcat:any=0;
  verifiedstatus:any;
  issuedetails:any={};
  bkcopies:any=1;
  clsdate:any=[];
  catwiseissued:any=[];
  arrdeptwisecollect:any=[];
  arrauthwisecollect:any=[];
  arrtitlewisecollect:any=[];
  arrsubjectwisecollect:any=[];
  arrpublisherwisecollect:any=[];
  arrsuplierwisecollect:any=[];
  arrsourcewisecollect:any=[];
  arrsectionwisecollect:any=[];
  arrpopcirculation:any=[]
  arraccndata:any=[];
  arractmember:any=[];
  arrcirdept:any=[];
  arrcirdate:any=[];
  arrcirmonth:any=[];
  arrfields:any=[];
  arracnseries:any=[];
  aldept:boolean=false;
  alsub:boolean=false;
  alsup:boolean=false;
  alsur:boolean=false;
  alsec:boolean=false;
  alpub:boolean=false;
  alcat:boolean=false;
  alacc:boolean=true;
  alauth:boolean=false;
  altitle:boolean=false;
  alnwarival:boolean=false;
  issuedinfocnt:any={};
  objqrprint:any={};
  objqrprintbulk:any={};
  objbkbulk:any={};
  nobc=1;
  frval='';
  toval='';
  qrdoctype='1UpQrcodeSpine';
  sertxt="";
  arrqrtypes:any=
  [{name:'1UP QR Code + Spine Lable Set',value:'1UpQrcodeSpine'},{name:'1UP Barcode + Spine Lable Set',value:'1UpBarSpine'},{name:'1UP Spine Lable',value:'1UpSpine'},
  {name:'1UP QR Code',value:'1UpQrcode'},
  {name:'1UP Barcode',value:'1UpBar'},
  {name:'2UP QR Code',value:'2UpQrcode'},
  {name:'2UP Barode',value:'2UpBar'},
  {name:'2UP QR Code(Zebra)',value:'2UpQrcodezebra'},
  {name:'Card Label',value:'Cardlabel'},
]
  
  constructor(private http: HttpClient, private liservice: LibraryService,private modalService: NgbModal,private _global: AppGlobals) {

    this.modalOptions = {
      backdrop:'static',
      backdropClass:'customBackdrop',
      size:'lg'
    }
    this.smmodalOptions = {
      backdrop:'static',
      backdropClass:'customBackdrop',
      size:'sm'
    }
   }

 
   public pieChartOptions: ChartOptions = {
    responsive: true,
    legend: {
        position: 'left',
      },
  };
 
  public catChartLabels: Label[] ;
  public catChartData: SingleDataSet ;
   public procureChartLabels: Label[] ;
   public procureChartData: SingleDataSet ;
   public procureChartType: ChartType = 'doughnut';
   public procureChartLegend = true;
   public procureChartPlugins = [];
   public procureChartColors: Color[] = [
     {backgroundColor:["#FF00CC","#0033FF","#99CC00","#FF3333","#FFFF66","#5EE8C6","#5EC2E8","#AF5EE8","#5EE8A1","#9505F9","#F9A005","#F90595","#BC3210","#A5E2ED"]},
     // {backgroundColor:["#9E120E","#FF5800","#FFB414"]},
     // {backgroundColor:["#9E120E","#FF5800","#FFB414"]}
   ];
    
   barChartOptions: ChartOptions = {
    responsive: true,
  };
  barChartLabels: Label[] = [];
  barChartType: ChartType = 'bar';
  barChartLegend = false;
  barChartPlugins = [];
  barChartColors: Color[] = [
    {
      
      backgroundColor: '#FF00CC',
    },
    {
     
      backgroundColor: '#0033FF',
    },
  ];
  barChartData: ChartDataSets[] = [
    // { data: [45, 37, 60, 70, 46, 33], label: 'Best Fruits' }
  ];
  ngOnInit(): void {
    this.getbookdetails();
    this.getdashcounts();
    this.getlibcategory();
    this.getlibdepartment();
    this.getlibpublisher();
    this.getlibsource();
    this.getlibsubjects();
    //this.getlibsupplier();
    this.getlibaccesiontype();
    this.getgenmasters('Bindingtype');
    this.getgenmasters('Currency');
    this.getgenmasters('Language');
    this.getslibmbksection();
    this.getfieldnames();
      this.getlibaccesiontype(); 
  
    //this.chartcirculation();
    this.Booksissue_received('nwarrivalyearly');
    

  }
  onfieldchange(obj)
  {
    debugger
//console.log('obj',this.objbkbulk);

  }

  onpubChangeSearch(sertxt) {
    debugger
    // fetch remote data from here
    // And reassign the 'data' which is binded to 'data' property.
    if(sertxt.query.length>=3) 
    {
      this.serlibpublisher(sertxt.query);
    }
  }

  onpubselectEvent(item) {
    //alert('hi');
        console.log('item',item);
        //this.selmember=item;
        //this.getissuedbookinfocnts(item.id);
      //  this.getissueddetails();
        // do something with selected item
      }

      onsupChangeSearch(sertxt) {
        debugger
        // fetch remote data from here
        // And reassign the 'data' which is binded to 'data' property.
        if(sertxt.query.length>=3) 
        {
          this.serlibsupplier(sertxt.query);
        }
      }
    
      onsupselectEvent(item) {
        //alert('hi');
            console.log('item',item);
            //this.selmember=item;
            //this.getissuedbookinfocnts(item.id);
          //  this.getissueddetails();
            // do something with selected item
          }


          onsubChangeSearch(sertxt) {
            debugger
            // fetch remote data from here
            // And reassign the 'data' which is binded to 'data' property.
            if(sertxt.query.length>=3) 
            {
              this.serlibsubjects(sertxt.query);
            }
          }
        
          onsubselectEvent(item) {
            //alert('hi');
                console.log('item',item);
                //this.selmember=item;
                //this.getissuedbookinfocnts(item.id);
              //  this.getissueddetails();
                // do something with selected item
              }

          onautocompselectEvent(item) {
            //alert('hi');
            if (this.selfield.value=='supid')
            {
          this.objbkbulk.newvalue=item.supid;

            }
            else if (this.selfield.value=='publisher')
            {
          this.objbkbulk.newvalue=item.pubid;

            }

            else if (this.selfield.value=='subjectid')
            {
          this.objbkbulk.newvalue=item.subid;

            }
                console.log('newvalue',item);
                //this.selmember=item;
                //this.getissuedbookinfocnts(item.id);
              //  this.getissueddetails();
                // do something with selected item
              }
    

  chartprocure()
{
  
  this.liservice.Getdashboarddata('chartbookprocure')
  .subscribe(
    
   resultArray =>{
    console.log('result',resultArray) ;
    this.clsdate=resultArray;

    //this.mutitest();
   // this.dataSource = new MatTableDataSource(resultArray);
   var arr = []
   var labelarr=[];


   for ( var i = 0; i < resultArray.length ; i++) {
    //console.log('multiarray -i',JSON.stringify(i));
     
          
    labelarr.push(resultArray[i].srcnm);
         
    arr.push(parseInt( resultArray[i].cnt));    
         
  }
    
   
    this.procureChartLabels = labelarr;
   this.procureChartData = arr;
   
   console.log("pieChartData ", this.procureChartLabels);
    },
   error => console.log("Error :: " + error)
)
}


chartcatcirculation()
{
  
  this.liservice.Getdashboarddata('catwiseissue')
  .subscribe(
    
   resultArray =>{
    console.log('result',resultArray) ;
    this.catwiseissued=resultArray;

    //this.mutitest();
   // this.dataSource = new MatTableDataSource(resultArray);
   var arr = []
   var labelarr=[];


   for ( var i = 0; i < resultArray.length ; i++) {
    //console.log('multiarray -i',JSON.stringify(i));
     
          
    labelarr.push(resultArray[i].bookcategory);
         
    arr.push(parseInt( resultArray[i].cnt));    
         
  }
    
   
    this.catChartLabels = labelarr;
   this.catChartData = arr;
   
   console.log("pieChartData ", this.catChartLabels);
    },
   error => console.log("Error :: " + error)
)
}
  dataview()
  {
this.deptwisecollect();
this.subjectwisecollect();
this.publisherwisecollect();
this.suplierwisecollect();
this.sourcewisecollect();
this.sectionwisecollect();
this.authorwisecollect();
this.titlewisecollect();
this.chartprocure();
this.chartcatcirculation();
this.chartaccssion();
//this.Booksissue_received('nwarrivalyearly');
this.newarrivals('nwarrivalmonthly');
//this.popcirculation();
  }

  chartaccssion()
{
  
  this.liservice.Getdashboarddata('chartbookaccsion')
  .subscribe(
    
   resultArray =>{
    console.log('result',resultArray) ;
    this.arraccndata=resultArray;

   
  //  var arr = []
  //  var labelarr=[];


  //  for ( var i = 0; i < resultArray.length ; i++) {
  //   //console.log('multiarray -i',JSON.stringify(i));
     
          
  //   labelarr.push(resultArray[i].acsnm);
         
  //   arr.push(parseInt( resultArray[i].cnt));    
         
  // }
    
   
  //   this.chartacsnChartLabels = labelarr;
  //  this.chartacsnChartData = arr;
   
  //  console.log("doughnutChartData ", this.chartacsnChartData);
    },
   error => console.log("Error :: " + error)
)
}
  deptwisecollect()
  {
      this.liservice.Getdashboarddata('collectdept')
    .subscribe(
           resultArray =>{
   // this.liservice.Getdashboarddata('dashcounts')
      console.log('result-dashcounts',resultArray) ;
      this.arrdeptwisecollect=resultArray;


      },
     error => console.log('Error :: ' + error)
  );
  }

  getaccno_series()
  {
      this.liservice.getaccno_series()
    .subscribe(
           resultArray =>{
   
      this.arracnseries=resultArray;


      },
     error => console.log('Error :: ' + error)
  );
  }
  subjectwisecollect()
  {
      this.liservice.Getdashboarddata('collectsubj')
    .subscribe(
           resultArray =>{
   // this.liservice.Getdashboarddata('dashcounts')
      console.log('result-dashcounts',resultArray) ;
      this.arrsubjectwisecollect=resultArray;


      },
     error => console.log('Error :: ' + error)
  );
  }
  publisherwisecollect()
  {
      this.liservice.Getdashboarddata('collectpublish')
    .subscribe(
           resultArray =>{
   // this.liservice.Getdashboarddata('dashcounts')
      console.log('result-dashcounts',resultArray) ;
      this.arrpublisherwisecollect=resultArray;


      },
     error => console.log('Error :: ' + error)
  );
  }


  authorwisecollect()
  {
      this.liservice.Getdashboarddata('collectauthor')
    .subscribe(
           resultArray =>{
   // this.liservice.Getdashboarddata('dashcounts')
      console.log('result-dashcounts',resultArray) ;
      this.arrauthwisecollect=resultArray;


      },
     error => console.log('Error :: ' + error)
  );
  }

  titlewisecollect()
  {
      this.liservice.Getdashboarddata('collecttitle')
    .subscribe(
           resultArray =>{
   // this.liservice.Getdashboarddata('dashcounts')
      console.log('result-dashcounts',resultArray) ;
      this.arrtitlewisecollect=resultArray;


      },
     error => console.log('Error :: ' + error)
  );
  }


  suplierwisecollect()
  {
      this.liservice.Getdashboarddata('collectsuply')
    .subscribe(
           resultArray =>{
   // this.liservice.Getdashboarddata('dashcounts')
      console.log('result-dashcounts',resultArray) ;
      this.arrsuplierwisecollect=resultArray;


      },
     error => console.log('Error :: ' + error)
  );
  }

 sourcewisecollect()
  {
      this.liservice.Getdashboarddata('collectsource')
    .subscribe(
           resultArray =>{
   // this.liservice.Getdashboarddata('dashcounts')
      console.log('result-dashcounts',resultArray) ;
      this.arrsourcewisecollect=resultArray;


      },
     error => console.log('Error :: ' + error)
  );
  }

  sectionwisecollect()
  {
      this.liservice.Getdashboarddata('collectsecn')
    .subscribe(
           resultArray =>{
   // this.liservice.Getdashboarddata('dashcounts')
      console.log('result-dashcounts',resultArray) ;
      this.arrsectionwisecollect=resultArray;


      },
     error => console.log('Error :: ' + error)
  );
  }
  ngAfterViewInit()
  {
    
  }
  calcdisnetamt()
  {
    this.booksmodel.netamt=this.booksmodel.prate-(this.booksmodel.prate * (this.booksmodel.disc/100));
  }
  savebookdetails()
  {

    this.booksmodel.publisher=this.selpub.pubid==undefined?0:this.selpub.pubid;
      this.booksmodel.supid=this.selsup.supid==undefined?0:this.selsup.supid;
      this.booksmodel.subjectid=this.selsub.subid==undefined?0:this.selsub.subid;
    console.log('savedetails',this.booksmodel);
    this.liservice.savelibbookmaster(this.booksmodel,this.oprtype)
.subscribe(result => {
   alert(result.message);
   
if(result.status=='Success')
{
  let localmodref=this.modalRef;
localmodref.close();
//this.Refreshsummary();
this.getbookdetails();
this.selpub={};
this.tab=1;

}


else{


}
   

  
    
}, error => alert('error in connection')
);
  }


  updbookmaster()
  {

var postdata={fieldname:this.selfield.value,newvalue:this.objbkbulk.newvalue,accnos:this.objbkbulk.accnos};
    console.log('savedetails',postdata);
    this.liservice.updbookmaster(postdata)
.subscribe(result => {
   alert(result.message);
   
if(result.status=='Success')
{
  let localmodref=this.modalRef;
localmodref.close();
//this.Refreshsummary();
this.getbookdetails();

}


else{


}
   

  
    
}, error => alert('error in connection')
);
  }

  bulksavebookdetails()
  {
    if(confirm("Are you sure to make bulk entries ? ")) {

      this.booksmodel.publisher=this.selpub.pubid==undefined?0:this.selpub.pubid;
      this.booksmodel.supid=this.selsup.supid==undefined?0:this.selsup.supid;
      this.booksmodel.subjectid=this.selsub.subid==undefined?0:this.selsub.subid;
    console.log('savedetails',this.booksmodel);
    this.liservice.bulksavelibbookmaster(this.booksmodel,this.bkcopies)
.subscribe(result => {
   alert(result.message);
   
if(result.status=='Success')
{
  debugger
  this.getbookdetails();
  let smalllocalmodref=this.smallmodalRef;
  smalllocalmodref.close();
let localmodref=this.modalRef;
localmodref.close();
this.selpub={};
this.tab=1;

}


else{


}
   

  
    
}, error => alert('error in connection')
);
    }
  }
  getbookdetails() {
    this.liservice.getbookdetails()
        .subscribe(
        resultArray => {
            console.log('books-result', resultArray);
            this.bookdetails = resultArray;
           // this.authorfilter();
          //   this.author  = resultArray [
          //     {'author'}
          // ];
        },
        error => console.log("Error :: " + error)
        )
}


getdashcounts() {
  this.liservice.booksdashcounts()
      .subscribe(
      resultArray => {
          console.log('getdashcounts', resultArray);
          this.dashcount = resultArray[0];
         
      },
      error => console.log("Error :: " + error)
      )
}

getgenmasters(mastype) {
  //de
  var resuarr=[];
return  this.liservice.getgenmasters(mastype)
      .subscribe(
      resultArray => {
          console.log('getgenmasters', resultArray);
          if(mastype=='Bindingtype')
          {
          this.bindtypes = resultArray;
          }
         else if(mastype=='Language')
          {
          this.laguages = resultArray;
          if (resultArray.length>0)
          {
          this.booksmodel.languageid=resultArray[0].id;
          }
          else
          {
            this.booksmodel.languageid='0';
          }
          }
         else if(mastype=='Currency')
          {
          this.currency = resultArray;
          if (resultArray.length>0)
          {
          this.booksmodel.currencyid=resultArray[0].id;
          }
          else
          {
            this.booksmodel.currencyid='0';
          }
          }
         
      },
      error => console.log("Error :: " + error)
      )
     
}
getlibsupplier() {
  this.liservice.getlibsupplier()
      .subscribe(
      resultArray => {
          console.log('getlibsupplier', resultArray);
          this.suppliers = resultArray;
         
      },
      error => console.log("Error :: " + error)
      )
}

serlibsupplier(sertxt) {
  this.liservice.serlibsupplier('serforbook',sertxt)
      .subscribe(
      resultArray => {
          console.log('getlibsupplier', resultArray);
          this.suppliers = resultArray;
         
      },
      error => console.log("Error :: " + error)
      )
}


getlibsubjects() {
  this.liservice.getlibsubjects()
      .subscribe(
      resultArray => {
          console.log('getlibsubjects', resultArray);
          this.subjects = resultArray;
         
      },
      error => console.log("Error :: " + error)
      )
}

serlibsubjects(sertxt) {
  this.liservice.serlibsubjects('serforbook',sertxt)
      .subscribe(
      resultArray => {
          console.log('getlibsubjects', resultArray);
          this.subjects = resultArray;
         
      },
      error => console.log("Error :: " + error)
      )
}

getlibcategory() {
  this.liservice.getlibcategory()
      .subscribe(
      resultArray => {
          console.log('getlibcategory', resultArray);
          this.catgories = resultArray;
          let resSTR = JSON.stringify(resultArray);
          console.log('jsonstrt',resSTR);
          this.composefiltercategory(resSTR);
      },
      error => console.log("Error :: " + error)
      )
}

composefiltercategory(jstring)
{
  var newstr = jstring.replace(/bkcatid/g, "value"); 
  var newstr = newstr.replace(/bkcatnm/g, "label"); 
  console.log('jsonrep',newstr);
  let resJSON = JSON.parse(newstr);
  var arr=Array.of(resJSON);
  let objval:any={};
  objval.label='All';
  objval.value='0';
  objval.status=0;
  arr[0].splice(0, 0, objval);
  this.filtcatgory=arr[0];
  console.log('filtcatgory',this.filtcatgory);
}
onChangefiltcat(selval)
{
debugger;
  //alert(selval);
this.selcat=selval;
}
getlibsource() {
  this.liservice.getlibsource()
      .subscribe(
      resultArray => {
          console.log('getlibsource', resultArray);
          this.sources = resultArray;
          
      },
      error => console.log("Error :: " + error)
      )
}

getfieldnames() {
  this.liservice.getbkfields()
      .subscribe(
      resultArray => {
          console.log('getlibsource', resultArray);
          this.arrfields = resultArray;
          
      },
      error => console.log("Error :: " + error)
      )
}

// getlibaccesiontype() {
//   this.liservice.getlibaccesiontype()
//       .subscribe(
//       resultArray => {
//           console.log('getlibaccesiontype', resultArray);
//          // console.log('getlibdepartment1',JSON.parse( resultArray));
//         // resultArray.forEach(x => x.status = x.status === 'true');
//           this.arracctype = resultArray;
          
//       },
//       error => console.log("Error :: " + error)
//       )
// }
getlibpublisher() {
  this.liservice.getlibpublisher("seltop10")
      .subscribe(
      resultArray => {
          console.log('getlibpublisher', resultArray);
          this.publishers = resultArray;
          
      },
      error => console.log("Error :: " + error)
      )
}

serlibpublisher(sertxt) {
  this.liservice.serlibpublisher("selforbookser",sertxt)
      .subscribe(
      resultArray => {
          console.log('serlibpublisher', resultArray);
          this.publishers = resultArray;
          
      },
      error => console.log("Error :: " + error)
      )
}
getlibdepartment() {
  this.liservice.getlibdepartment()
      .subscribe(
      resultArray => {
          console.log('getlibdepartment', resultArray);
          this.depts = resultArray;
          
      },
      error => console.log("Error :: " + error)
      )
}
getlibaccesiontype() 
{

  this.liservice.getlibaccesiontype()
      .subscribe(
      resultArray => {
          console.log('getlibaccesiontype', resultArray);
          this.acctypes = resultArray;
          
      },
      error => console.log("Error :: " + error)
      )
}


getslibmbksection() {
  this.liservice.getslibmbksection()
      .subscribe(
      resultArray => {
          console.log('getslibmbksection', resultArray);
          this.lsection = resultArray;
          
      },
      error => console.log("Error :: " + error)
      )
}
authorfilter()
{
var autharr=this.bookdetails;
  // this.author = autharr.filter(
  //   (thing, i, arr) => arr.findIndex(t => t.author === thing.author) === i
  // );
  var farr= Array.from(new Set(autharr.map((item: any) => item.author)));
 
  var auth=[];
  for(var i=0;i<farr.length;i++)
  {
    debugger
     let objval:Dropobj;
objval.label=farr[i]
objval.value=farr[i];
console.log('obj',objval);
auth.push(objval);
  }
this.author=auth;
  console.log('auths',auth);
//   this.statuses = [
//     {label: 'Unqualified', value: 'unqualified'},
//     {label: 'Qualified', value: 'qualified'},
//     {label: 'New', value: 'new'},
//     {label: 'Negotiation', value: 'negotiation'},
//     {label: 'Renewal', value: 'renewal'},
//     {label: 'Proposal', value: 'proposal'}
// ]

}
applybooksFilter(filterValue: string) {
  filterValue = filterValue.trim(); // Remove whitespace
  filterValue = filterValue.toLowerCase(); // MatTableDataSource defaults to lowercase matches
  

  if(filterValue.length>=3)
  {
    debugger
    this.sertxt=filterValue;
    var oprtype='allbook';
    var bkcat=0;
    if (this.selcat==0||this.selcat=='0')
    {
      oprtype='allbook';
      bkcat=0;
    }

    else
    {
      oprtype='serbycat';
      bkcat=this.selcat;
    }
  this.liservice.serchbooks(filterValue,oprtype,bkcat)
  .subscribe(
  resultArray => {
      console.log('books-result', resultArray);
      this.bookdetails = resultArray;
    // this.authorfilter();
      
  },
  error => console.log("Error :: " + error)
  )
}
else 
{
  this.getbookdetails();
}

}

openinfo(content)
{

  this.modalRef=this.modalService.open(content,this.modalOptions);
  
  this.modalRef.result.then((result) => {
 
       // this.Asmtdetls(asid);
        this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
}

opendet(content)
{
this.getaccno_series();
this.modalOptions.size='sm';
  this.modalRef=this.modalService.open(content,this.modalOptions);
  
  this.modalRef.result.then((result) => {
 
       // this.Asmtdetls(asid);
        this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
}

openbulkupdate(content)
{
  this.objbkbulk={};
  this.getfieldnames();

  this.modalRef=this.modalService.open(content,this.modalOptions);
  
  this.modalRef.result.then((result) => {
 
       // this.Asmtdetls(asid);
        this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
}

openqrdl(content,bkid)
{
  this.objqrprint.bkid=bkid;
  this.objqrprint.nobc=1;
  this.objqrprint.qrdoctype='1UpQrcodeSpine';


  this.modalRef=this.modalService.open(content,this.smmodalOptions);
  
  this.modalRef.result.then((result) => {
 
       // this.Asmtdetls(asid);
        this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
}


openqrdlbulk(content)
{
  //this.objqrprint.bkid=bkid;
  this.objqrprintbulk.nobc=1;
  this.objqrprintbulk.qrdoctype='1UpQrcodeSpine';
  this.objqrprintbulk.pretxt='';


  this.modalRef=this.modalService.open(content,this.smmodalOptions);
  
  this.modalRef.result.then((result) => {
 
       // this.Asmtdetls(asid);
        this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
}
openbookdialog(content,formdata,cmd) {
  debugger
  console.log("formdata",formdata);

  this.oprtype=cmd;
  if(cmd=='insert')
  {
    this.booksmodel={};
   
    if (this.laguages.length>0)
    {
    this.booksmodel.languageid=this.laguages[0].id;
    }
    else
    {
      this.booksmodel.languageid='0';
    }

    if (this.currency.length>0)
    {
    this.booksmodel.currencyid=this.currency[0].id;
    }
    else
    {
      this.booksmodel.currencyid='0';
    }
    this.booksmodel.bkid=0;
    this.booksmodel.strmedia=0;
    this.booksmodel.crby=0;
    this.booksmodel.mdby=0;
    this.booksmodel.bksecid=0;
   // this.booksmodel.languageid='1';
    this.booksmodel.bkstatus='Available';
    this.booksmodel.bindtype='Paper Back';
    this.booksmodel.publisher='1';
    this.booksmodel.source='1';
    this.booksmodel.deptid='1';
    this.booksmodel.bkcatid='1';
    this.booksmodel.subjectid='1';
    this.booksmodel.supid='1';
    //this.booksmodel.currencyid=1;
    this.booksmodel.accnstatus='10';
    this.booksmodel.verifiedstatus='Yes';
    this.booksmodel.accno='';
    this.booksmodel.author='';
    this.booksmodel.authorccode='';
    this.booksmodel.billdt=this.liservice.getdatetoday();
    this.booksmodel.pubplace='';
    this.booksmodel.pubyr='';
    this.booksmodel.series='';
    this.booksmodel.title='';
    this.booksmodel.titlesub='';
    this.booksmodel.volume='';
    this.booksmodel.billno='';
    this.booksmodel.callno='';
    this.booksmodel.classno='';
    this.booksmodel.disc='0';
    this.booksmodel.edition='';
    this.booksmodel.isbn='';
    this.booksmodel.location='';
    this.booksmodel.mrp='0';
    this.booksmodel.netamt='0';
    this.booksmodel.pages='0';
    this.booksmodel.prate='0';
    this.booksmodel.location='';
    this.booksmodel.keywords='';
    this.booksmodel.remarks='';
 


    this.modalRef=this.modalService.open(content,this.modalOptions);
  
   this.modalRef.result.then((result) => {
  
        // this.Asmtdetls(asid);
         this.closeResult = `Closed with: ${result}`;
     }, (reason) => {
         this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
     });
  }
  else if (cmd=='update')
  {
//     if(formdata.recordstatus=='Active')
// {
    this.booksmodel=formdata;
    this.selpub.pubnm=formdata.pubnm;
    this.selpub.pubid=formdata.publisher;

    this.selsup.supnm=formdata.supnm;
    this.selsup.supid=formdata.supid;

    this.selsub.subnm=formdata.subnm;
    this.selsub.subid=formdata.subjectid;
    
    this.modalRef=this.modalService.open(content,this.modalOptions);
  
   this.modalRef.result.then((result) => {
  
        // this.Asmtdetls(asid);
         this.closeResult = `Closed with: ${result}`;
     }, (reason) => {
         this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
     });
//}
  }
  
  
    
  

}
private getDismissReason(reason: any): string {
  if (reason === ModalDismissReasons.ESC) {
    return 'by pressing ESC';
  } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
    return 'by clicking on a backdrop';
  } else {
    return  `with: ${reason}`;
  }
}

 qropen(bkid){
  var clcd=localStorage.getItem('clcd');
  var aycd=localStorage.getItem('aycd');
   var url=this.liservice.callurl+"qrcode/qrcode.php?clcd="+clcd+"&aycd="+aycd+"&bkid="+bkid;

   window.open(url,'','_blank');
 }

 printqrlabels(obj){
debugger;
  var clcd=localStorage.getItem('clcd');
  var aycd=localStorage.getItem('aycd');
   var url=this.liservice.callurl+"qrcode/"+obj.qrdoctype+".php?clcd="+clcd+"&aycd="+aycd+"&bkid="+obj.bkid+"&noc="+obj.nobc;
   window.open(url,'','');
 }

 printqrlabelsbulk(obj){
  debugger;
    var clcd=localStorage.getItem('clcd');
    var aycd=localStorage.getItem('aycd');
     var url=this.liservice.callurl+"qrcode/"+obj.qrdoctype+"bulk.php?clcd="+clcd+"&aycd="+aycd+"&pretxt="+obj.pretxt+"&noc="+obj.nobc+"&from="+obj.rfrm+"&to="+obj.rto;
     window.open(url,'','');
   }

 exportbookmas(accid,tag,value){
  var clcd=localStorage.getItem('clcd');
  var aycd=localStorage.getItem('aycd');
   var url=this.liservice.callurl+"export/expbookmaster.php?clcd="+clcd+"&aycd="+aycd+"&accnstatus="+accid+"&tag="+tag+"&value="+value+"&sertxt="+this.sertxt;

  // window.open(url,'','_blank');
  window.open(url);
 }

 exportnewbooks(month,year){
  var clcd=localStorage.getItem('clcd');
  var aycd=localStorage.getItem('aycd');
   var url=this.liservice.callurl+"export/expnewarivalbook.php?clcd="+clcd+"&aycd="+aycd+"&month="+month+"&year="+year;
   //window.open(url,'','_blank');
   window.open(url);


   
 }
 exportbookcollect(oprtype,tag){
  var clcd=localStorage.getItem('clcd');
  var aycd=localStorage.getItem('aycd');
   var url=this.liservice.callurl+"export/expbookscollection.php?clcd="+clcd+"&aycd="+aycd+"&oprtype="+oprtype+"&tag="+tag;

  // window.open(url,'','_blank');
  //window.open(url,'','_blank');
  window.open(url);
 }
 getissueddetails(bookid) {
  this.liservice.getissuedbookdetails(bookid,'issuedbkdtks')
      .subscribe(
      resultArray => {
          console.log('issueddata', resultArray);
          this.issuedetails = resultArray[0];
        //issuedbktomem  
          
      },
      error => console.log("Error :: " + error)
      )
}

toggleActivation($event){
  if ($event.checked){
    this.newarrivals('nwarrivalyearly');

  }
else
{
  this.newarrivals('nwarrivalmonthly');

}}

  newarrivals(oprtype)
  {

    this.liservice.Getdashboarddata(oprtype)
    .subscribe(
    resultArray => {
        console.log('newarr'+oprtype, resultArray);
        this.arrnewar = resultArray;
      //issuedbktomem  
        
    },
    error => console.log("Error :: " + error)
    )
  }
Booksissue_received(oprtype)
{
  //this.liservice.Getdashboarddata('catwiseissue')
  this.liservice.Getdashboarddata(oprtype)
  .subscribe(
    
   resultArray =>{

    console.log('Booksissue_received-'+oprtype,resultArray) ;
    //this.clsdate=resultArray;
    var arr = [];
    var issued = [];
    var returned = [];
    for ( var i = 0; i < resultArray.length ; i++) {
      //console.log('multiarray -i',JSON.stringify(i));
       
            
            arr.push(resultArray[i].mnth);
           // issued.push(parseInt( resultArray[i].issued)); // 
            returned.push(parseInt( resultArray[i].bkcnt));
            
           
    }
   
   this.barChartData = [
      { data: returned, label: '', 
     },
     
    ];
     this.barChartLabels = arr;
  
   
    
    
   // this.dataSource = new MatTableDataSource(resultArray);
    },
   error => console.log("Error :: " + error)
)
}

chartcirculation()
{
  this.liservice.Getdashboarddata('catwiseissue')
  //this.liservice.Getdashboarddata(oprtype)
  .subscribe(
    
   resultArray =>{

    console.log('chartcirculation-',resultArray) ;
    //this.clsdate=resultArray;
    var arr = [];
    var issued = [];
    var returned = [];
    for ( var i = 0; i < resultArray.length ; i++) {
      //console.log('multiarray -i',JSON.stringify(i));
       
            
            arr.push(resultArray[i].bookcategory);
           // issued.push(parseInt( resultArray[i].issued)); // 
            returned.push(parseInt( resultArray[i].icnt));
            
           
    }
   
   this.barChartData = [
      { data: returned, label: '', 
     },
     
    ];
     this.barChartLabels = arr;
  
   
    
    
   // this.dataSource = new MatTableDataSource(resultArray);
    },
   error => console.log("Error :: " + error)
)
}

getissuedhistory(bookid) {
  this.liservice.getissuedbookdetails(bookid,'issuedhistory')
      .subscribe(
      resultArray => {
          console.log('issuehis', resultArray);
          this.issuehis = resultArray;
          this.getissuedbookinfocnts(bookid);
          
          
      },
      error => console.log("Error :: " + error)
      )
}

getissuedbookinfocnts(bookid) {
  this.liservice.getissuedbookcnts(bookid)
      .subscribe(
      resultArray => {
          console.log('issueddata', resultArray);
          this.issuedinfocnt = resultArray[0];
        //issuedbktomem  
          
      },
      error => console.log("Error :: " + error)
      )
}
openissuedhisdialog(content,bookid,obj) {
  debugger
  this.bookinfo=obj;
  this.getissuedhistory(bookid);
  this.modalOptions = {
    backdrop:'static',
    backdropClass:'customBackdrop',
    
   
  }
  this.modalRef=this.modalService.open(content,this.modalOptions);
  
  this.modalRef.result.then((result) => {
 
       
    }, (reason) => {
        
    });
}

openissueddialog(content,bookid) {
  
  this.getissueddetails(bookid);
  this.modalOptions = {
    backdrop:'static',
    backdropClass:'customBackdrop',
    
   
  }
  this.modalRef=this.modalService.open(content,this.modalOptions);
  
  this.modalRef.result.then((result) => {
 
       
    }, (reason) => {
        
    });
}

generateaccnseeries(acccno,size)
{
  debugger
  var result = acccno.match(/[^\d]+|\d+/g);
  var alfa='';
  var num='';
  
  if (result.length==null || result.length==0)
  {
    alert('Please enter valid accession number');
  }
  else 
  {
  if(result.length==1)
  {
alfa='';
num=result[0];
    
  }

  else if(result.length>1)
  {
alfa=result[0];
num=result[1];
    

  }

  var numseries=acccno+',';
  this.frval=acccno;
const zeroPad = (num, places) => String(num).padStart(places, '0');
  var numvalue=parseInt(num);
  for(let i=0;i<size;i++)
  {
   
    var nwseries=alfa+zeroPad(numvalue, num.length);
    //numseries=numseries+nwseries+',';
if(size>1)
{
this.toval=nwseries;
}
else{
  this.toval='';
}
numvalue=numvalue+1;
  }

  // console.log('numseries',numseries);
  // alert("Accession No's are :"+numseries);
  }
}

openbulkdialog(content) {

this.generateaccnseeries(this.booksmodel.accno,this.bkcopies);
  
  
 var smallmodalOptions:NgbModalOptions = {
    backdrop:'static',
    backdropClass:'customBackdrop',
    size:'sm'
   
  }
  this.smallmodalRef=this.modalService.open(content,smallmodalOptions);
  
  this.smallmodalRef.result.then((result) => {
 
       
    }, (reason) => {
        
    });
}

}
